<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/JobAgentScore'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ปี :</label>
                 
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(YYYY)"
                      id="odYear"
                      name="odYear"
                      ref="odYear"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div> 

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เดือน :</label>
                  <select2
                    :key="'odMonth-' + odMonthKey"
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'odMonth'"
                    :name="'odMonth'"
                    :select2-options="odMonthOptions"
                    v-model="odMonth"
                    ref="odMonthSelect2"
                  ></select2>
                </div>
              </div> 

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reCommitDateStart"
                      name="reCommitDateStart"
                      ref="reCommitDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reCommitDateEnd"
                      name="reCommitDateEnd"
                      ref="reCommitDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div> 
               
            </div>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <treeselect
                    v-model="reAaAgentCode"
                    :multiple="true"
                    :options="reAaAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทใบงาน:</label>
                  <treeselect
                    v-model="reJobGroupType"
                    :multiple="true"
                    :options="reJobGroupTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อสินค้า :</label>

                  <treeselect
                    v-model="MbSKUId"
                    :multiple="true"
                    :options="MbSKUOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

            </div>
 

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportData"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>  
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

           
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="reportTable"
              >
                <thead>
                  <tr>
                    <!-- <th class="all"> ลำดับ	</th> -->
                    <th class="all text-center"> ปี</th>
                    <th class="all text-center"> เดือน</th>
                    <th class="all text-center"> วันที่</th>
                    <th class="all text-center"> โรงงาน</th>
                    <th class="all text-center"> รหัสตัวแทนฯ</th>
                    <th class="all text-center"> ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center"> ประเภทใบงาน</th>
                    <th class="all text-center"> จำนวนใบงาน</th>
                    <th class="all text-center"> ชื่อสินค้า /จำนวนสินค้า</th> 
 
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";
import { each } from "jquery";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
  
export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
        isLoadData : false ,
        odYear:  moment() ,
        reJobGroupType:null,
        reCommitDateStart : null,
        reCommitDateEnd : null,
        MbSKUOptions: [],
        MbSKUId: [],
        reAaAgentCode: [],
        reAaAgentCodeOptions: [],
        odMonth :  moment().format("M"),
        odMonthKey : 0,
        reJobGroupTypeOptions : [],
        odMonthOptions: {
          placeholder: "ทั้งหมด",
          allowClear: true,
          data: [
            { "id": "1",  "text": "มกราคม",   "data": null },
            { "id": "2",  "text": "กุมภาพันธ์", "data": null },
            { "id": "3",  "text": "มีนาคม",    "data": null },
            { "id": "4",  "text": "เมษายน",    "data": null },
            { "id": "5",  "text": "พฤษภาคม",   "data": null },
            { "id": "6",  "text": "มิถุนายน",   "data": null },
            { "id": "7",  "text": "กรกฎาคม",   "data": null },
            { "id": "8",  "text": "สิงหาคม",   "data": null },
            { "id": "9",  "text": "กันยายน",   "data": null },
            { "id": "10", "text": "ตุลาคม",    "data": null },
            { "id": "11", "text": "พฤศจิกายน", "data": null },
            { "id": "12", "text": "ธันวาคม",   "data": null }
          ]
        }
    };
  },
  methods: {
    formReset: function(e) {
      if (e) e.preventDefault();
      let self = this;
      self.odYear =   moment();
      self.odMonth = moment().format("M");
      self.MbSKUId = [];
      self.reJobGroupType= [];
      self.reAaAgentCode = [];
      self.reCommitDateStart =null;
      self.reCommitDateEnd =null;

      self.odMonthKey++;

      $(self.$refs.odYear).datepicker("update", self.odYear.format("YYYY"));
      $(self.$refs.reCommitDateStart).datepicker("update", null);
      $(self.$refs.reCommitDateEnd).datepicker("update", null);

      $("#reJobGroupType")
        .val("")
        .trigger("change");

    },
    formResetValue: function (e) {
      let self = this;
      self.odYear = moment();
      self.odMonth = null;
      self.MbSKUId = [];
      self.reJobGroupType= [];
      self.reCommitDateStart =null;
      self.reCommitDateEnd =null;
        
      $("#odMonth")
        .val("")
        .trigger("change");

      $("#reJobGroupType")
        .val("")
        .trigger("change");

       this.formSubmit(e, "ล้างค่าทั้งหมด");
    }, 
    exportData: function(e) {
      e.preventDefault();
      let self = this;
      self.isLoadData = true ;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/AgentScore/ExportData",
        responseType: "arraybuffer",
        data: {
            Year: self.odYear.format("YYYY"),
            StartDate:
              self.reCommitDateStart != null
                ? self.reCommitDateStart.format("DD/MM/YYYY")
                : self.reCommitDateStart,
            EndDate:
              self.reCommitDateEnd != null
                ? self.reCommitDateEnd.format("DD/MM/YYYY")
                : self.reCommitDateEnd,
            Month: self.odMonth,
            GroupJobTypeCode: self.reJobGroupType,
            ProductGroupCode: self.MbSKUId,
            AgentCodeSap: self.reAaAgentCode,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
           // link.download = decodeURIComponent(filename);
             link.download =
             moment().format("YYYY-MM-DD") +"_รายงานคะแนนการทำระบบเบียร์สด"+
            ".xlsx";
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    formSubmit: function(e) {
      e.preventDefault();
      this.isLoadData = true ;
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {

      $("#reportTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    // LoadMbSKUOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Product/Select2Product", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.MbSKUOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // }, 

    LoadreJobGroupTypeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/AgentScore/Select2JobTypeAgentGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reJobGroupTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },  
    LoadMbSKUOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbSKUOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAaAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: [],
            AgentCodes: [],
            page: 1,
            IsShowInAgentScoreReport: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAaAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },      
  },
  async mounted() {
    let self = this;
    self.LoadMbSKUOptions();
    self.LoadreJobGroupTypeOptions();
    self.LoadreAaAgentCodeOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }


     $.fn.dataTable.ext.errMode = 'none';
    var table = $("#reportTable");

    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/AgentScore/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                IsLoadData : self.isLoadData ,
                Year: self.odYear.format("YYYY"),
                StartDate:
                  self.reCommitDateStart != null
                    ? self.reCommitDateStart.format("DD/MM/YYYY")
                    : self.reCommitDateStart,
                EndDate:
                  self.reCommitDateEnd != null
                    ? self.reCommitDateEnd.format("DD/MM/YYYY")
                    : self.reCommitDateEnd,
                Month: self.odMonth,
                GroupJobTypeCode: self.reJobGroupType,
                ProductGroupCode: self.MbSKUId,
                AgentCodeSap: self.reAaAgentCode,

              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 50,

        language: {
          lengthMenu: "Display _MENU_",
        },

        //ลำดับ	ปี	เดือน	วันที่	โรงงาน	รหัสตัวแทนฯ	ชื่อตัวแทนจำหน่าย			ประเภทใบงาน	จำนวนใบงาน	ชื่อสินค้า /จำนวนสินค้า 

        // Order settings
        order: [[2, "asc"]],
        columns: [
          //{ data: "month", className: "text-center" },
          { data: "year", className: "text-center" },
          { data: "monthTH", className: "text-left" },
          {
            data: "commitDate",
            className: "text-left",
            width: "5%",
            render: function(data, type, full, meta) { 
              return full.commitDateText;
            },
          } ,
          { data: "plants", className: "text-left" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-left" },
          { data: "groupJobTypeName", className: "text-left" },
          { data: "totalJob", className: "text-center" }, 
          {
            data: "materialSummary",
            className: "text-left",
            width: "20%",
            render: function(data, type, full, meta) {
              let div = '<div class="row"> '; 
                  full.materialSummaryList.forEach((item, index) => {
                    div += '<div class="col-12"> ' + item + '</div> ' ;
                  }); 
                  div += '</div> ';


              return div;
            },
          } 
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
         
      });

    //self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reCommitDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reCommitDateStart = moment().set("date",1);
    $(self.$refs.reCommitDateStart)
      .datepicker(
        "update",
        !!self.reCommitDateStart
          ? self.reCommitDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reCommitDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reCommitDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reCommitDateEnd = moment().endOf('month');
    $(self.$refs.reCommitDateEnd)
      .datepicker(
        "update",
        !!self.reCommitDateEnd
          ? self.reCommitDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reCommitDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });
 
     if (!self.odYear) {
      self.odYear = moment();
    }

     $(self.$refs.odYear).datepicker({
      format: "yyyy",
      viewMode: "years",
      minViewMode: "years",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    $(self.$refs.odYear).datepicker(
      "update",
      !!self.odYear ? self.odYear.format("YYYY") : null
    ).on("changeDate", function(e) {
      self.odYear = e.dates.length != 0 ? moment(e.date) : null;
    });
  } 
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/JobAgentScore.vue